import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { INTERVIEW_MODES } from "@/lib/constants";
import { CalendarPlus } from "lucide-react";

export default function InterviewScheduler({ applicationId, onScheduled }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ scheduled_at: "", mode: "visio", location_or_link: "", notes: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post(`/applications/${applicationId}/interviews`, {
        ...form,
        scheduled_at: new Date(form.scheduled_at).toISOString(),
      });
      setOpen(false);
      setForm({ scheduled_at: "", mode: "visio", location_or_link: "", notes: "" });
      onScheduled?.();
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        data-testid={`interview-open-${applicationId}`}
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-blue border border-brand-blue/30 rounded-lg px-3 py-1.5 hover:bg-brand-sky"
      >
        <CalendarPlus className="w-3.5 h-3.5" />
        Entretien
      </button>
    );
  }

  const inputCls = "border border-slate-300 rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-brand-blue";

  return (
    <form data-testid={`interview-form-${applicationId}`} onSubmit={submit} className="inline-flex flex-wrap items-center gap-2">
      <input
        data-testid={`interview-date-${applicationId}`}
        required
        type="datetime-local"
        value={form.scheduled_at}
        onChange={(e) => setForm({ ...form, scheduled_at: e.target.value })}
        className={inputCls}
      />
      <select
        data-testid={`interview-mode-${applicationId}`}
        value={form.mode}
        onChange={(e) => setForm({ ...form, mode: e.target.value })}
        className={`${inputCls} bg-white`}
      >
        {INTERVIEW_MODES.map((m) => (
          <option key={m.value} value={m.value}>{m.label}</option>
        ))}
      </select>
      <input
        data-testid={`interview-location-${applicationId}`}
        value={form.location_or_link}
        onChange={(e) => setForm({ ...form, location_or_link: e.target.value })}
        placeholder="Lieu ou lien"
        className={inputCls}
      />
      <button
        data-testid={`interview-submit-${applicationId}`}
        type="submit"
        disabled={submitting}
        className="text-xs font-semibold text-white bg-brand-blue rounded-lg px-3 py-1.5 hover:bg-brand-navy disabled:opacity-50"
      >
        {submitting ? "…" : "Planifier"}
      </button>
      <button type="button" onClick={() => setOpen(false)} className="text-xs text-slate-500 hover:text-slate-700">
        Annuler
      </button>
      {error && <span data-testid={`interview-error-${applicationId}`} className="text-xs text-red-600">{error}</span>}
    </form>
  );
}
